import { useFormikContext } from "formik";
import React, { FC } from "react";
import { WizardSummaryLayout } from '../../../components/wizard/wizard-summary-layout';
import { CustomFieldBuilder } from "../../../containers/utilities/CustomFieldBuilder";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    supportedFields?: any[];
    modeName?: string;
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined, supportedFields = undefined, modeName }) => {
    const { translate } = useLocale();
    const formik = useFormikContext();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)} onSubmit={onNext ? (e) => onNext(e) : undefined}>
            <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.mode)}: <span className="text-sm text-black">{modeName}</span></h4>
            <br />
            <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.outputStates)}</h2>
            {supportedFields
                ? supportedFields.reduce((formFields, field) => customFieldBuilder.buildSummaryField(formFields, field), new Array(0))
                    .map(fieldBundle => <div className="flex flex-row">{fieldBundle.length === 1
                        ? fieldBundle[0].span
                            ? fieldBundle[0].content
                            : <>{fieldBundle[0].content}
                                <div className="flex flex-col flex-1 pl-3"></div></>
                        : fieldBundle.map(field => field.content)}</div>)
                : <span>{translate.byKey(TranslationKeys.noContent)}</span>}
    </WizardSummaryLayout>;
};
